import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { Switch, Table, Avatar, Button } from "antd"
import { Container, Row, Col } from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import Breadcrumb from "../../../components/Common/Breadcrumb"
import { getApplicationClients, clientStatusChange } from "store/clients/action"

//i18n
import { withTranslation } from "react-i18next"
import { useSelector, useDispatch, shallowEqual } from "react-redux"

const LetzeroLandlords = props => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [clientsList, setClientList] = useState([])
  const { applicationTwoClients } = useSelector(
    state => state.AppClients,
    shallowEqual
  )

  useEffect(() => {
    if (applicationTwoClients) {
      const modifiedArray = applicationTwoClients.map(client => ({
        ...client,
        name: `${client.first_name} ${client.last_name}`,
      }))
      setClientList([])
    }
  }, [applicationTwoClients])

  useEffect(() => {
    const application_type = 2
    dispatch(getApplicationClients(application_type))
  }, [])

  function statusChange(data) {
    if (data === 1) {
      return 0
    } else if (data === 0) {
      return 1
    } else {
      return null
    }
  }

  const columns = [
    {
      title: "Landlord Name",
      dataIndex: "name",
      align: "center",
    },
    {
      title: "Address",
      dataIndex: "address",
      align: "center",
    },
    {
      title: "Email",
      dataIndex: "email",
      align: "center",
    },
    {
      title: "Contact",
      dataIndex: "mobile",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      render: (data, record) => (
        <Switch
          style={{
            backgroundColor: data === 1 ? "green" : "red",
          }}
          onChange={() => {
            const payload = {
              application_type: 2,
              org_id: record?.id,
              value: statusChange(data),
            }
            dispatch(clientStatusChange(payload))
          }}
          checked={data === 1 ? true : false}
        />
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      align: "center",
      render: (data, record) => (
        <Button
          type="primary"
          onClick={() =>
            navigate("/cave-update-client", {
              state: { record, backToList: "/cave-clients-list" },
            })
          }
        >
          Edit
        </Button>
      ),
    },
  ]

  document.title = "Landlords List | TRUST"
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title="Let Zero"
            dashboardRoute="/letzero-dashboard"
            breadcrumbItem="Landlords List"
          />
          <Row>
            <Col>
              <Button
                type="primary"
                style={{
                  float: "right",
                }}
                onClick={() => navigate("/letzero-landlords001")}
              >
                + Add New Landloard
              </Button>
            </Col>
          </Row>
          <Row>
            <Table
              scroll={{
                x: 1300,
              }}
              columns={columns}
              dataSource={clientsList}
            />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

LetzeroLandlords.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(LetzeroLandlords)
